import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  StyledTextTitle,
  StyledTextSubTitle,
  StyledText,
} from '../components/Utils/TextStyles';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Card, CardContent } from '@material-ui/core';
import DividerWithText from '../components/Utils/Divider';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: '90vh',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  container: {
    textAlign: 'center',
    position: 'relative',
    zIndex: '2',
  },
  cardRoot: {
    minWidth: 275,
    backgroundColor: '#e2e1e1',
    alignSelf: 'center',
    textAlign: 'center',
  },
  image: {
    position: 'absolute',
    left: '5%',
    top: '5%',
    width: '30%',
    maxWidth: '200px',
    opacity: '0.5',
  },
}));

export default function Mensaje() {
  const classes = useStyles();
  return (
    <div id='gran-dia'>
      <div className={classes.container}>
        <img
          src={process.env.PUBLIC_URL + '/assets/ByU-071.png'}
          className={classes.image}
        />
        <Card className={classes.cardRoot} elevation={0}>
          <CardContent>
            <div
              className='info'
              // style={{
              //   backgroundRepeat: 'no-repeat',
              //   backgroundPosition: 'left',
              //   backgroundSize: 'contain',
              //   backgroundImage: `url(${
              //     process.env.PUBLIC_URL + '/assets/ByU-071.png'
              //   })`,
              // }}
            >
              <div>
                <StyledTextSubTitle
                  color={'#00774f'}
                  style={{ textAlign: 'center' }}
                >
                  “El mejor tipo de amor es aquel que despierta el alma y nos
                  hace aspirar a más, nos enciende el corazón y nos trae paz a
                  la mente. Eso es lo que tú me has dado y lo que yo esperaba
                  darte siempre”
                </StyledTextSubTitle>
                <StyledText color={'#bb823f'} style={{ textAlign: 'center' }}>
                  ¡Nos casamos!
                </StyledText>
                <StyledTextSubTitle
                  color={'#00774f'}
                  style={{ textAlign: 'center' }}
                >
                  Y nos hace mucha ilusión compartir este día con ustedes.
                </StyledTextSubTitle>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <DividerWithText />
    </div>
  );
}
